
import { z } from "zod";
import { sanitizeTextInput } from "@/utils/security/inputSanitization";

// Secure text validation with XSS prevention
const secureTextSchema = z
  .string()
  .transform((text) => sanitizeTextInput(text))
  .refine(
    (text) => !/<script[^>]*>.*?<\/script>/gi.test(text),
    'Script tags are not allowed'
  );

export const EventSchema = z.object({
  title: secureTextSchema
    .refine((text) => text.length >= 1, "Title is required")
    .refine((text) => text.length <= 1000, "Text too long"),
  description: secureTextSchema.optional(),
  date: z.date(),
  startTime: z.string().regex(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, "Invalid time format"),
  endTime: z.string().regex(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, "Invalid time format"),
  location: secureTextSchema.optional(),
  type: z.string(),
  attendees: secureTextSchema.optional(),
});

export type EventFormValues = z.infer<typeof EventSchema>;

export const eventTypes = [
  { value: 'interview', label: 'Interview' },
  { value: 'screening', label: 'Screening' },
  { value: 'research', label: 'Candidate Research' },
  { value: 'client', label: 'Client Engagement' },
  { value: 'prospecting', label: 'Prospecting' },
  { value: 'other', label: 'Other' },
];
